// Shared filter vocabulary for appointments.
// These values must match backend/constants/appointment.js exactly — the
// strings are sent straight through to the API as query params.

export const APPOINTMENT_STATUS = {
  PENDING: "pending",
  CREATED: "created",
  CONFIRMED: "confirmed",
  RESCHEDULED: "rescheduled",
  DELAYED: "delayed",
  CHECKED_IN: "checked_in",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

// Mirrors ACTIVE_STATUSES on the backend: everything that hasn't reached a
// terminal state. This is what the "Upcoming" tab means.
export const ACTIVE_STATUSES = [
  APPOINTMENT_STATUS.PENDING,
  APPOINTMENT_STATUS.CREATED,
  APPOINTMENT_STATUS.CONFIRMED,
  APPOINTMENT_STATUS.RESCHEDULED,
  APPOINTMENT_STATUS.DELAYED,
  APPOINTMENT_STATUS.CHECKED_IN,
];

export const STATUS_LABEL = {
  [APPOINTMENT_STATUS.PENDING]: "Pending",
  [APPOINTMENT_STATUS.CREATED]: "Created",
  [APPOINTMENT_STATUS.CONFIRMED]: "Confirmed",
  [APPOINTMENT_STATUS.RESCHEDULED]: "Rescheduled",
  [APPOINTMENT_STATUS.DELAYED]: "Delayed",
  [APPOINTMENT_STATUS.CHECKED_IN]: "Checked In",
  [APPOINTMENT_STATUS.COMPLETED]: "Completed",
  [APPOINTMENT_STATUS.CANCELLED]: "Cancelled",
};

// Not a stored status — a computed one (see backend's isMissed): active,
// never checked in, and its slot time has already passed.
export const MISSED_STATUS = "missed";

// Also computed (see backend's isDelayed): today's slot time has passed and
// the patient isn't checked in, but the doctor's session is still running.
export const DELAYED_STATUS = "late";

// Only the active statuses are offered in the filter — Completed and
// Cancelled are reachable through their own tabs. "Missed" is appended
// since it's a view onto a subset of the active statuses, not a tab.
export const STATUS_OPTIONS = [
  ...ACTIVE_STATUSES.map((value) => ({ value, label: STATUS_LABEL[value] })),
  { value: DELAYED_STATUS, label: "Delay" },
  { value: MISSED_STATUS, label: "Missed" },
];

export const VISIT_TYPE = {
  ONLINE: "video", // stored as "video" so existing rows keep working
  CENTER: "center",
  HOME: "home",
  WALKIN: "walkin",
};

export const VISIT_TYPE_LABEL = {
  [VISIT_TYPE.ONLINE]: "Online",
  [VISIT_TYPE.CENTER]: "Center Visit",
  [VISIT_TYPE.HOME]: "Home Visit",
  [VISIT_TYPE.WALKIN]: "Walk In",
};

export const VISIT_TYPE_OPTIONS = [
  { value: VISIT_TYPE.ONLINE, label: VISIT_TYPE_LABEL[VISIT_TYPE.ONLINE] },
  { value: VISIT_TYPE.CENTER, label: VISIT_TYPE_LABEL[VISIT_TYPE.CENTER] },
  { value: VISIT_TYPE.HOME, label: VISIT_TYPE_LABEL[VISIT_TYPE.HOME] },
  { value: VISIT_TYPE.WALKIN, label: VISIT_TYPE_LABEL[VISIT_TYPE.WALKIN] },
];

export const DELAY_STATUS = {
  PROVIDER_DELAYED: "provider_delayed",
  PATIENT_DELAYED: "patient_delayed",
  PROVIDER_NO_SHOW: "provider_no_show",
  PATIENT_NO_SHOW: "patient_no_show",
  MEETING_COMPLETED: "meeting_completed",
};

export const DELAY_STATUS_LABEL = {
  [DELAY_STATUS.PROVIDER_DELAYED]: "Provider Delayed",
  [DELAY_STATUS.PATIENT_DELAYED]: "Patient Delayed",
  [DELAY_STATUS.PROVIDER_NO_SHOW]: "Provider No Show",
  [DELAY_STATUS.PATIENT_NO_SHOW]: "Patient No Show",
  [DELAY_STATUS.MEETING_COMPLETED]: "Meeting Completed",
};

export const DELAY_STATUS_OPTIONS = Object.values(DELAY_STATUS).map((value) => ({
  value,
  label: DELAY_STATUS_LABEL[value],
}));
